import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { Passo } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useDeletePasso, usePasso, useUpdatePasso } from '../../hooks/passi'
import PassoForm from '../../components/PassoForm'

export default function PassoEdit() {
  const { id } = useParams()
  const { data: passo } = usePasso(+id!)
  const deletePasso = useDeletePasso()
  const updatePasso = useUpdatePasso()
  const [modalRm, modalRmActions] = useModalTrigger<Passo>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/passi">Passi</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {passo!.opera_data?.titolo}
            </li>
          </ol>
        </nav>
        <div className="d-flex align-items-center">
          <button
            className="btn btn-danger"
            onClick={() => modalRmActions.open(passo)}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </div>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <PassoForm
          passo={passo}
          save={(passo) =>
            updatePasso.mutateAsync(passo).then(() =>
              toast.success('Passo salvato con successo!', {
                position: toast.POSITION.TOP_RIGHT,
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare il passo {modalRm.value.opera_data?.titolo}?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn btn-danger"
            disabled={deletePasso.isLoading}
            onClick={async () => {
              await deletePasso.mutateAsync(modalRm.value!.id)
              navigate('/passi')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
